// src/components/FloatingBugButton.tsx
import React, { useState, useEffect, lazy, Suspense } from "react";
import { BugAntIcon } from "@heroicons/react/24/outline";

const BugReportModal = lazy(async () => ({ default: (await import("./BugReportModal")).BugReportModal }));

type Props = {
    /** Sätt inline=true för att använda knappen i en toolbar (ingen floating-klass) */
    inline?: boolean;
    /** Extra klasser när du kör inline (t.ex. "btn--ghost") */
    className?: string;
    /** Egen label om du vill korta ner */
    label?: string;
};

export const FloatingBugButton: React.FC<Props> = ({
    inline = false,
    className,
    label = "Bugrapport",
}) => {
    const [open, setOpen] = useState(false);

    // ESC stänger modal
    useEffect(() => {
        const onKey = (e: KeyboardEvent) => {
            if (e.key === "Escape") setOpen(false);
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, []);

    const buttonClass = [
        "gw-btn",
        inline ? "gw-btn-ghost" : "floating-bug-btn",
        className ?? "",
    ].filter(Boolean).join(" ");

    return (
        <>
            <button
                type="button"
                className={buttonClass}
                aria-label="Rapportera bugg"
                onClick={() => setOpen(true)}
            >
                <BugAntIcon className="h-5 w-5" />
                <span className="hidden md:inline">{label}</span>
            </button>

            {open && (
                <Suspense
                    fallback={
                        <div className="gw-modal-overlay">
                            <div className="gw-modal-card max-w-[420px] p-4 text-center text-muted">
                                Laddar buggrapportformulär…
                            </div>
                        </div>
                    }
                >
                    <BugReportModal onClose={() => setOpen(false)} />
                </Suspense>
            )}
        </>
    );
};
